import { render, staticRenderFns } from "./TrimLevels.vue?vue&type=template&id=3d63c58c&"
import script from "./TrimLevels.vue?vue&type=script&lang=js&"
export * from "./TrimLevels.vue?vue&type=script&lang=js&"
import style0 from "./TrimLevels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d63c58c')) {
      api.createRecord('3d63c58c', component.options)
    } else {
      api.reload('3d63c58c', component.options)
    }
    module.hot.accept("./TrimLevels.vue?vue&type=template&id=3d63c58c&", function () {
      api.rerender('3d63c58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/TrimLevels.vue"
export default component.exports